import PropTypes from "prop-types"
import React, { createContext } from "react"

export const ImportHistoryContext = createContext(null)

export function ImportHistoryContextProvider({ currentUserId, children }) {
  return (
    <ImportHistoryContext.Provider value={{ currentUserId }}>
      {children}
    </ImportHistoryContext.Provider>
  )
}

ImportHistoryContextProvider.propTypes = {
  currentUserId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}
